import { KeyboardReturn } from '@mui/icons-material'
import { Stack } from '@mui/material'
import { useFormikContext } from 'formik'
import { get } from 'lodash'
import { useTypedTranslation } from '~/common/hooks/useTypedTranslation'
import { controlKey } from '~/common/utils/keymap'
import { hasCellDataChanged } from '~/common/utils/table-cell'
import { LoadingButton } from '~/components/ui/molecules/loading-button/LoadingButton'
import { CellValue } from '../records/add-record/AddRecordDialog'
import { RecordDetailTableCell } from '../records/types'
import { EditTableCellFormStates } from './EditTableCellDialog'

interface EditTableCellFormButtonsProps {
  editTableCellFormStates: EditTableCellFormStates
  handleCancel: () => void
  cellId: string
  cells: RecordDetailTableCell[]
  isDirty: boolean
}

/**
 * Buttons for the record details form (save, cancel, edit)
 */
export function EditTableCellFormButtons(props: EditTableCellFormButtonsProps) {
  const { t } = useTypedTranslation()
  const { editTableCellFormStates } = props
  const formikProps = useFormikContext<Record<string, CellValue>>()

  const disabledActions =
    formikProps.isSubmitting ||
    formikProps.isValidating ||
    editTableCellFormStates.isLoading ||
    editTableCellFormStates.isSuccess ||
    editTableCellFormStates.isFailure

  let hasChangedValue = false
  const cell = props.cells.find((cell) => cell.id === props.cellId)
  if (cell) {
    const newValue = get(formikProps.values, cell.column.id, undefined)
    hasChangedValue = hasCellDataChanged(
      cell.column,
      cell.data,
      newValue,
      cell.lookupCells.map((lookupCell) => lookupCell.id),
      cell.documents.map((document) => document.id),
      cell.users.map((user) => user.id),
    )
  }

  const disabledSubmit =
    disabledActions || !props.isDirty || !formikProps.isValid || !hasChangedValue

  return (
    <Stack direction="row" spacing={1}>
      <LoadingButton
        autoFocus
        disabled={disabledSubmit}
        endIcon={controlKey(<KeyboardReturn />)}
        loading={props.editTableCellFormStates.isLoading}
        onClick={() => formikProps.handleSubmit()}
        size={'small'}
        type="button"
        variant="primary"
      >
        {t('common.actions.save')}
      </LoadingButton>
    </Stack>
  )
}
